import { OccurrenceHistoryEntry } from '../models/occurrence-history';

export class GetOccurrenceHistories {
  static entries: OccurrenceHistoryEntry[] = [];

  private static nextId = 1;

  static addEntry(entry: Omit<OccurrenceHistoryEntry, 'id'>): OccurrenceHistoryEntry {
    const full: OccurrenceHistoryEntry = { ...entry, id: this.nextId++ };
    this.entries.push(full);
    return full;
  }
}
